import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard that permits activation only when the current user's JWT
 * contains at least one `loja_ids` claim value matching the requested
 * route, or the user has the 'admin' role (global access).
 *
 * Route usage example:
 *   { path: ':id/editar', canActivate: [lojaEscopoGuard], ... }
 */
export const lojaEscopoGuard: CanActivateFn = (_route, _state) => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  const role = auth.getRole();

  // Admins have unrestricted access to all users
  if (role === 'admin') return true;

  // All other roles are not allowed to access this route
  router.navigate(['/app/acesso-negado']);
  return false;
};
